import { withRouter, NextRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { SitecoreForm } from '@sitecore-jss/sitecore-jss-forms';
import { classnames } from 'tailwindcss-classnames';
import RingLoader from 'react-spinners/RingLoader';

import useDictionary from 'lib/sitecore/use-dictionary';

export type JssNextFormProps = {
  fields: SitecoreForm;
  router: NextRouter;
};

const JssNextForm = ({ fields, router }: JssNextFormProps) => {
  const dictionary = useDictionary();
  const labelFormLoading = dictionary?.Forms_Loading ?? 'Loading';
  const Form = dynamic(() => import('components/helpers/SitecoreForm/components/form'));
  if (!router?.isReady) {
    return (
      <div className={classnames('w-full', 'flex', 'flex-col', 'items-center', 'justify-center')}>
        <h3 className={classnames('heading-xs', 'pb-3')}>{labelFormLoading}</h3>
        <RingLoader color="#00355E" loading aria-label={labelFormLoading} />
      </div>
    );
  }
  return <Form form={fields} locale={router.locale} onRedirect={router.push} />;
};

export default withRouter(JssNextForm);
